import localization from "../../../config/localization";
import { Button } from "../../ui";

export function AppBanner({ handleNavigate }: { handleNavigate: (path: string) => void }) {


  return (
    <div className="mx-4 mt-6 rounded-xl hover:cursor-pointer hover:opacity-80 transition" onClick={() => handleNavigate("/android-app")}>
      <div className="flex items-center justify-between rounded-xl bg-[linear-gradient(90deg,#000000_45%,#470010_100%)] p-4">
        <div className="flex items-center gap-3">
          <img src={"/images/logo.svg"} alt="Sky365" className="w-12 h-12 rounded-md" />
          <span className="text-white text-xl font-semibold">
            Sky365 {localization.App}
          </span>
        </div>

        <Button className="bg-primary-gradient hover:bg-emerald-500 transition text-white text-md px-4 py-1.5 rounded-lg">
          {localization.GetApp}
        </Button>
      </div>
    </div>
  );
}
